import React from 'react';
import moment from 'moment';
import cn from 'classnames';

import tableStyles from '../table.module.scss';
import { Tooltip } from 'antd';

const CreateDateCell = ({ record }) => {
  return (
    <Tooltip title="Дата создания">
      <div className={cn(tableStyles.tdItem, tableStyles.dateCell)}>
        {moment(record.createDate).format('DD.MM.YYYY')}
      </div>
    </Tooltip>
  );
};

export default CreateDateCell;
